module.exports = __webpack_public_path__ + "img/adouy3.c0d281f7.png";